import React from 'react';
import FinanceFinancingProspectingWorkspace from './financing/FinanceFinancingProspectingWorkspace';

const FinanceFinancingWorkspace = ({ isDarkMode = false }) => (
  <FinanceFinancingProspectingWorkspace isDarkMode={isDarkMode} />
);

export default FinanceFinancingWorkspace;
